import React from 'react';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';

import RecentSales from '../../../fastlane/recentSales/RecentSales';

import styles from './SocialProof.scss';

export const SocialProof = () => {
  const onRefTrigger = () => HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.SOCIAL_PROOF);

  return (
    <RecentSales
      carouselClassName={styles.recentSalesCarouselWrapper}
      className={styles.recentSalesWrapper}
      onLoad={onRefTrigger}
    />
  );
};
